"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formConstants = exports.classes = exports.fieldWidth = exports.IS_SLACK = void 0;
var IS_SLACK = 'slack';
exports.IS_SLACK = IS_SLACK;
var fieldWidth = '512px';
exports.fieldWidth = fieldWidth;
var classes = {
  stepperMainContainer: 'policy-approval-tab-main-container',
  addPolicyFieldWrapper: 'sm-add-policy-field-wrapper',
  formNameLoaderWrapper: 'sm-form-name-loader-wrapper',
  formNameCheckLoader: 'sm-form-name-check-loader',
  addPolicyFieldValueWrapper: 'sm-add-policy-field-value-wrapper',
  notificationTableContainer: 'sm-table-container',
  valueWrapper: 'sm-value-wrapper',
  infoIcon: 'info-icon'
};
exports.classes = classes;
var formConstants = {
  slackbotText: 'slackapp',
  teamsbotText: 'teamsapp',
  Any: 'Any',
  All: 'All',
  Manager: 'Manager'
};
exports.formConstants = formConstants;